import { combineReducers } from 'redux';

import Router from './reducer/Router.reducer';
import User from './reducer/User.reducer';
import Live from './reducer/Live.reducer';
import CourseInfo from './reducer/CourseInfo.reducer';
import UserCenter from './reducer/UserCenter.reducer';
import Vod from './reducer/Vod.reducer';
import Subject from './reducer/Subject.reducer';
import Grade from './reducer/Grade.reducer';
import schools from './reducer/school.reducer';
import searchResult from './reducer/search.reducer';
import recommendTeachers from './reducer/RecommendTeacher.reducer';
import banners from './reducer/SchoolBanners.reducer';
export default combineReducers({
    Router,
    User,
    Live,
    UserCenter,
    CourseInfo,
    Vod,
    Subject,
    Grade,
    schools,
    searchResult,
    recommendTeachers,
    banners
});



// WEBPACK FOOTER //
// ./src/redux/combineReducer.js